<template>
  <div :class="['info-block']">
    <h2 v-if="title" v-html="title" />
    <div>
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoBlock',
  props: {
    /**
     * Box title
     */
    title: {
      type: String,
      required: false
    }
  }
}
</script>
<style>
.info-block
{
  color: #f2f2f2;
  background: rgba(0, 0, 0, .5);
  backdrop-filter: blur(6px);
  border-radius: .5em;
  text-align: left;
  justify-content: left;
  padding: 1em;
  font: normal .5em Helvetica, Arial, "Helvetica Neue", sans-serif;
  border: solid 1px #f2f2f2;
  width: 80%;
}

.info-block a
{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// info-block.vue?3004c915